import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import axios from 'axios';
import VueAxios from 'vue-axios';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import PrimeVue from 'primevue/config';
import 'primeicons/primeicons.css';
import FontAwesomeIcon from "@/fontawesome";
import Myi18n from './i18n';
import globalerror from '@/core/services/base/GlobalError';
import '@/assets/styles/site.css';
import '@/assets/styles/themes/default.css';
import '@/assets/styles/themes/dark_default.css';
/*Los css agregados despues de 'site.css' tienen preferencia ya que estan despues del site.css por lo tanto son los estilos con mayor prioridad.*/
import '@/assets/styles/responsive/site-desk.css';
import '@/assets/styles/responsive/site-desk-small.css';
import '@/assets/styles/responsive/site-small.css';
import '@/assets/styles/responsive/site-xtra-small.css';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import DialogService from 'primevue/dialogservice';
import jsonLangEsDefault from '@/locales/es.json';
import BadgeDirective from 'primevue/badgedirective';


const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(VueAxios, axios);
app.use(Myi18n);
app.use(PrimeVue,{locale:{...jsonLangEsDefault.prime}});
app.component("FontAwesomeIcon", FontAwesomeIcon)
app.use(ToastService);
app.use(DialogService);
app.use(ConfirmationService);
app.directive('badge', BadgeDirective);
app.config.errorHandler = globalerror;
app.mount('#app');
